import { render, staticRenderFns } from "./download-apk-mobile.vue?vue&type=template&id=3baf1c54"
import script from "./download-apk-mobile.vue?vue&type=script&lang=js"
export * from "./download-apk-mobile.vue?vue&type=script&lang=js"
import style0 from "./download-apk-mobile.vue?vue&type=style&index=0&id=3baf1c54&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports